export const EVENT_PROPERTIES_STORAGE_KEY = 'event_properties'
